import { CategoryEffects } from './category.effects';
export const effects: any[] = [CategoryEffects];
